module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ded"
  }, [_c('i', [_vm._v("To the memory of Ali Abdoh, old Tehran’s boss of bosses, and to his grandson, Ashil.")])]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_c('i', [_vm._v("In addition to the remarkable efforts and patience of the writers themselves, there are several friends who should be especially acknowledged in this anthology: Hooshyar Ansaarifar, Mitra Elyati, Maryam Haidari, Somayeh Nasiriha, and Hassan Shahsavari. A warm thanks to each and every one of you for your invaluable suggestions and encouragement. This book could not have come together as it did without you.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1349558c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/dedt.vue
// module id = 69
// module chunks = 0